import { render } from "./PrintTestData.vue?vue&type=template&id=70b18096&scoped=true"
import script from "./PrintTestData.vue?vue&type=script&lang=js"
export * from "./PrintTestData.vue?vue&type=script&lang=js"

import "./PrintTestData.vue?vue&type=style&index=0&id=70b18096&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70b18096"]])

export default __exports__